import { Slider } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { borderRadius, fontSize, getSpacing } from 'stylesheetB2b';

const TIME_SLIDER_HEIGHT = getSpacing(1);
const TIME_SLIDER_THUMB_SIZE = getSpacing(3);

const commonThumbStyle = {
  height: TIME_SLIDER_THUMB_SIZE,
  width: TIME_SLIDER_THUMB_SIZE,
};

export const TimeContainer = styled.div`
  display: flex;
  width: 100%;
`;
TimeContainer.displayName = 'TimeContainer';

export const RemainingTime = styled.span`
  display: flex;
  align-items: center;
  font-size: ${fontSize.small};
  flex-shrink: 0;
`;
RemainingTime.displayName = 'RemainingTime';

export const TimeSlider = muiStyled(Slider)<{ colors: ColormapInterface }>(({ colors }) => ({
  flex: 1,
  height: TIME_SLIDER_HEIGHT,
  padding: `${getSpacing(2)} 0`,
  marginRight: getSpacing(5),
  color: colors.timeSliderRail,
  '& .MuiSlider-disabled': {
    color: colors.timeSliderDisabled,
  },

  '& .MuiSlider-track': {
    height: TIME_SLIDER_HEIGHT,
    backgroundColor: colors.timeSliderTrackAndThumb,
    border: 0,
  },
  '& .MuiSlider-thumb': {
    ...commonThumbStyle,
    backgroundColor: colors.timeSliderTrackAndThumb,

    '& .Mui-disabled': {
      ...commonThumbStyle,
      backgroundColor: colors.timeSliderDisabled,
    },
  },
  '& .MuiSlider-rail': {
    height: TIME_SLIDER_HEIGHT,
    borderRadius: borderRadius.rounded,
    opacity: 1,
  },
}));
